import './index.css'
import * as React from 'react'
import { connect } from 'react-redux'
import type { State } from 'types/redux'
import { updatePlaylistReportParams } from '@disco/state-management/actions/ReportActions'
import { getTrialStartDate } from '@disco/state-management/selectors/user'
import DateRangePicker from 'components/common/date-range-picker'

function mapStateToProps(state: State): any {
  const { startDate, endDate } = state.reports.playlistReport.form
  return {
    trialStartDate: getTrialStartDate(state),
    startDate,
    endDate,
  }
}

function mapDispatchToProps(dispatch: any): any {
  return {
    onChange(startDate: Date, endDate: Date): void {
      dispatch(
        updatePlaylistReportParams({
          startDate: startDate,
          endDate: endDate,
        }),
      )
    },
  }
}

class ReportDate extends React.Component<{
  trialStartDate: Date
  startDate: Date
  endDate: Date
  onChange: (startDate: Date, endDate: Date) => void
  disabled?: boolean
}> {
  render() {
    return (
      <div className="ReportDate">
        <DateRangePicker
          autoApply
          applyButton={false}
          compact
          minDate={this.props.trialStartDate}
          maxDate={new Date()}
          startDate={this.props.startDate}
          endDate={this.props.endDate}
          showPredefinedRanges
          onChange={this.props.onChange}
          disabled={this.props.disabled}
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDate) as any
